// Auto-generated entry for blockmapboxMapInner.cshtml

import 'mapbox-gl/dist/mapbox-gl.css';
import '@/styles/Global/Controls/ControlMaps.scss';
import '@/scripts/Site/Maps/Locations.Mapbox.js';

import mapboxgl from 'mapbox-gl';

// expose global for legacy scripts that expect `window.mapboxgl`
(window as any).mapboxgl = mapboxgl;
